import React from 'react';
import TextResponse from './responses/TextResponse';
import ChoiceResponse from './responses/ChoiceResponse';
import StatementResponse from './responses/StatementResponse';
import FiveStarReviewResponse from './responses/FiveStarReviewResponse';
import DatePickerResponse from './responses/DatePickerResponse';
import FileUploadResponse from './responses/FileUploadResponse';

const QuestionResponse = ({ question, questionNumber, response, onUpdate, error, formId }) => {
  const renderQuestionContent = () => {
    switch (question.type) {
      case 'SHORT_TEXT':
        return (
          <TextResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            isParagraph={false}
          />
        );

      case 'PARAGRAPH':
        return (
          <TextResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            isParagraph={true}
          />
        );

      case 'MULTIPLE_CHOICE':
        return (
          <ChoiceResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            type="radio"
          />
        );

      case 'CHECKBOX':
        return (
          <ChoiceResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            type="checkbox"
          />
        );

      case 'DROPDOWN':
        return (
          <ChoiceResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            type="dropdown"
          />
        );

      case 'STATEMENT':
        return (
          <StatementResponse
            question={question}
          />
        );

      case 'FIVE_STAR_REVIEW':
        return (
          <FiveStarReviewResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
          />
        );

      case 'DATE_PICKER':
        return (
          <DatePickerResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
          />
        );

      case 'FILE_UPLOAD':
        return (
          <FileUploadResponse
            question={question}
            response={response}
            onUpdate={onUpdate}
            formId={formId}
          />
        );

      default:
        return (
          <div className="alert alert-warning">
            Unsupported question type: {question.type}
          </div>
        );
    }
  };

  return (
    <div className={`bg-white rounded-3 p-4 shadow-sm mb-3 border transition-all ${error ? 'border-danger' : 'border-light'}`}>
      <div className="mb-3">
        <div className="d-flex align-items-start justify-content-between mb-2">
          <h5 className="mb-0 fw-medium" style={{ fontSize: '1.1rem' }}>{question.title}</h5>
          {question.required && <span className="text-danger small fw-bold">*</span>}
        </div>
        {question.description && (
          <p className="text-secondary small mb-0">
            {question.description}
          </p>
        )}
      </div>

      <div className="mt-3">
        {renderQuestionContent()}
      </div>

      {error && (
        <div className="text-danger small mt-2 d-flex align-items-center gap-1">
          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
          {error}
        </div>
      )}
    </div>
  );
};

export default QuestionResponse;
